import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { getMySubscription } from "../../api/subscription";

const MAX_ATTEMPTS = 8;
const INTERVAL_MS = 1500;

export default function CheckoutSuccess() {
  const history = useHistory();
  const [status, setStatus] = useState("polling");
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const poll = async () => {
      try {
        const res = await getMySubscription();
        const sub = res.data;
        if (cancelled) return;

        if (sub?.stripe_subscription_id && sub?.status === "active") {
          setSubscription(sub);
          setStatus("ready");
          return;
        }
      } catch (_) {
        /* keep polling */
      }

      attempts += 1;
      if (attempts >= MAX_ATTEMPTS) {
        setStatus("timeout");
        return;
      }
      setTimeout(poll, INTERVAL_MS);
    };

    poll();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          width: "100%",
          p: { xs: 3, md: 5 },
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          textAlign: "center",
        }}
      >
        {status === "polling" && (
          <Stack spacing={2} alignItems="center">
            <CircularProgress />
            <Typography variant="h6" fontWeight={600}>
              Confirmando seu pagamento…
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Isso costuma levar poucos segundos.
            </Typography>
          </Stack>
        )}

        {status === "ready" && (
          <Stack spacing={2} alignItems="center">
            <CheckCircleIcon sx={{ fontSize: 72, color: "success.main" }} />
            <Typography variant="h5" fontWeight={700}>
              Assinatura ativada!
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Seu plano <strong>{subscription?.plan_details?.name}</strong> está
              ativo. Você já pode usar todos os recursos liberados.
            </Typography>
            <Button
              variant="contained"
              size="large"
              sx={{ textTransform: "none", fontWeight: 600, mt: 1 }}
              onClick={() => history.push("/minha-assinatura")}
            >
              Ver minha assinatura
            </Button>
          </Stack>
        )}

        {status === "timeout" && (
          <Stack spacing={2} alignItems="center">
            <Typography variant="h6" fontWeight={600}>
              Pagamento recebido
            </Typography>
            <Typography variant="body2" color="text.secondary">
              A ativação pode levar alguns instantes. Você pode voltar para a
              página da assinatura — ela será atualizada automaticamente.
            </Typography>
            <Button
              variant="contained"
              onClick={() => history.push("/minha-assinatura")}
              sx={{ textTransform: "none", fontWeight: 600 }}
            >
              Voltar para Minha Assinatura
            </Button>
          </Stack>
        )}
      </Paper>
    </Box>
  );
}
